import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import MDBox from "components/MDBox";

function Filter({ filterText, onFilter, onClear }) {
  return (
    <MDBox container mr="auto" ml={-1.3}>
      <MDInput
        id="search"
        type="text"
        label="Filter table data"
        value={filterText}
        onChange={onFilter}
      />
      <MDButton
        sx={{ borderRadius: "0px 6px 6px 0px", padding: "1.8em" }}
        iconOnly
        variant="gradient"
        color="info"
        onClick={onClear}
      >
        X
      </MDButton>
    </MDBox>
  );
}

export default Filter;
